export default (props, vars) => {
  return vars?.['useapplicationoffer2']?.['applicationOffer']?.job_description;
};
